import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-brand-cream px-4 py-6 sm:px-6" data-id="element-75">
      <div className="rounded-lg border-2 border-brand-rose/40 bg-brand-beige p-4 text-center shadow-sm" data-id="element-76">
        <p className="mb-2 text-xs font-bold tracking-wider text-brand-burgundy" data-id="element-77">
          DEINE INVESTITION IST ZU 100% GESCHÜTZT
        </p>
        <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full border border-brand-gold/50 bg-brand-goldLight" data-id="element-78">
          <ShieldCheckIcon className="h-6 w-6 text-brand-burgundy" data-id="element-79" />
        </div>
        <h2 className="mb-2 text-2xl font-bold leading-tight" data-id="element-80">
          🛡️ 7 Tage Geld-zurück-Garantie
        </h2>
        <p className="whitespace-pre-line text-[13px] font-medium leading-relaxed" data-id="element-81">
          Dein Kauf ist vollständig risikolos.{'\n\n'}Nimm dir sieben volle
          Tage, um das gesamte System zu erkunden, alle sechs Module
          durchzugehen, deine Unterrichtsstunden zu organisieren, die Vorlagen
          und Ressourcen umzusetzen und das komplette Planungssystem in deinem
          echten Unterrichtsalltag anzuwenden.{'\n\n'}Wenn du aus irgendeinem
          Grund nicht vollständig überzeugt bist, kontaktiere uns einfach
          innerhalb der ersten 7 Tage und wir erstatten dir 100% deines
          Kaufbetrags zurück.{'\n\n'}Kein Risiko. Keine Fragen. Kein Stress.
        </p>
      </div>
    </section>;
}